import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface CompanyInfo {
  id: string;
  name: string;
  role?: string;
  isPrimary?: boolean;
}

interface ProfileState {
  name: string;
  email: string;
  phone: string;
  primaryCompany: string;
  companies: CompanyInfo[];
  avatarUrl?: string;
  setProfile: (patch: Partial<Omit<ProfileState, "companies" | "setProfile" | "addCompany" | "updateCompany" | "removeCompany" | "setPrimary">>) => void;
  addCompany: (c: Omit<CompanyInfo, "id" | "isPrimary">) => void;
  updateCompany: (id: string, patch: Partial<CompanyInfo>) => void;
  removeCompany: (id: string) => void;
  setPrimary: (id: string) => void;
}

const uid = () => "co" + Math.random().toString(36).slice(2, 9);

export const useProfile = create<ProfileState>()(
  persist(
    (set) => ({
      name: "Marcio",
      email: "r3rentalcar@gmail.com",
      phone: "",
      primaryCompany: "R3 Group LLC",
      companies: [
        { id: "c1", name: "R3 Group LLC", role: "CEO / Founder", isPrimary: true }
      ],
      setProfile: (patch) => set(patch),
      addCompany: (c) => set(s => ({
        companies: [...s.companies, { ...c, id: uid() }]
      })),
      updateCompany: (id, patch) => set(s => ({
        companies: s.companies.map(c => c.id === id ? { ...c, ...patch } : c)
      })),
      removeCompany: (id) => set(s => ({
        companies: s.companies.filter(c => c.id !== id)
      })),
      setPrimary: (id) => set(s => ({
        companies: s.companies.map(c => ({ ...c, isPrimary: c.id === id })),
        primaryCompany: s.companies.find(c => c.id === id)?.name ?? s.primaryCompany
      }))
    }),
    { name: "agencia-vpc-profile-v1" }
  )
);
